import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Error404PageComponent } from './modules/pages/components/error404-page/error404-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { MainLayoutComponent } from './shared/layout/main-layout/main-layout.component';
import { LoginLayoutComponent } from './shared/layout/login-layout/login-layout.component';
import { BlankLayoutComponent } from './shared/layout/blank-layout/blank-layout.component';

const routes: Routes = [
  {
    path: 'auth',
    component: LoginLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/auth/auth.module').then((m) => m.AuthModule),
      },
    ],
  },
  {
    path: 'maintenance',
    component: BlankLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/maintenance/maintenance.module').then(
            (m) => m.MaintenanceModule
          ),
      },
    ],
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./modules/home/home.module').then((m) => m.HomeModule),
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./modules/account/account.module').then(
            (m) => m.AccountModule
          ),
      },
      {
        path: 'races',
        loadChildren: () =>
          import('./modules/races/races.module').then((m) => m.RacesModule),
      },
      {
        path: 'race',
        loadChildren: () =>
          import('./modules/race/race.module').then((m) => m.RaceModule),
      },
      {
        // Friendly alias for the provider lobby: the nav item reads GOLDEN, so
        // /golden must land somewhere. It redirects rather than mounting a
        // second copy of the module — one canonical url keeps the guards, the
        // layout's lobby-mode check and any bookmark on a single path.
        path: 'golden',
        redirectTo: 'virtuals',
        pathMatch: 'full',
      },
      {
        // Provider lobby (GoldenRace / Softquo virtuals). MUST stay above the
        // empty-path static-pages mount below, which would otherwise swallow
        // the slug. Gated inside the module by ProvidersEnabledGuard +
        // AuthGuard; production ships with the flag off.
        path: 'virtuals',
        loadChildren: () =>
          import('./modules/virtuals/virtuals.module').then(
            (m) => m.VirtualsModule
          ),
      },
      {
        // Static info pages (/bet-types, /deposit-withdrawal-tn,
        // /terms-and-conditions). Empty-path mount so the slugs live at the
        // site root; the router falls through to it after the siblings above
        // fail to match (same mechanism every non-home URL relies on).
        path: '',
        loadChildren: () =>
          import('./modules/static-pages/static-pages.module').then(
            (m) => m.StaticPagesModule
          ),
      },
      { path: '**', component: Error404PageComponent },
    ],
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
